module.exports = __webpack_public_path__ + "img/icon-notsure.467a5c0f.svg";